export const notifySubscriptions = function(newEvents,subscriptionChangedEventName ){
    if(!subscriptionChangedEventName)
        return;
    const event = new CustomEvent(subscriptionChangedEventName, { detail: newEvents});
    document.dispatchEvent(event);
};